import {
  BaseScenario,
  FindAllOptions,
  HistoryEvent,
  Job,
  Scenario,
  Typeahead,
  parse,
} from './models/scenario';

import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions = {}): Promise<Scenario[]> {
    const url = this.common.constructPath(`/scenarios`, options);
    const results = await this.common.getJSON(url);
    return results.map(parse);
  }

  async findAllTypeahead(
    options: Partial<{ organizationId: string }> = {},
  ): Promise<Typeahead[]> {
    const url = this.common.constructPath('/scenarios/typeahead', options);
    return this.common.getJSON(url);
  }

  async findAllJobs(): Promise<Job[]> {
    const url = this.common.constructPath('/scenarios/jobs');
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<Scenario> {
    const url = this.common.constructPath(`/scenarios/${id}`);
    const result = await this.common.getJSON(url);
    return parse(result);
  }

  async findHistory(id: string): Promise<HistoryEvent[]> {
    const url = this.common.constructPath(`/scenarios/${id}/history`);
    return this.common.getJSON(url);
  }

  async create(values: BaseScenario): Promise<Scenario> {
    const url = this.common.constructPath(`/scenarios`);
    const result = await this.common.postJSON(url, values);
    return parse(result);
  }

  async update(id: string, values: BaseScenario): Promise<Scenario> {
    const url = this.common.constructPath(`/scenarios/${id}`);
    const result = await this.common.patchJSON(url, values);
    return parse(result);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`/scenarios/${id}`);
    return this.common.deleteJSON(url);
  }
}
